import React from 'react';

const UploadProfileImage = () => {
	return (
		<div>
			<h2 id="tasks_image">Upload a Profile Image</h2>
			<p>You can upload a user’s profile picture using one of two methods. The first method is using a POST with a mime-multipart form type. This is useful when uploading from a browser and is how the JS SDK uploads images. The second way is to use a PUT and to upload the binary image directly. This mechanism is best when performing an upload from another server.</p>
			<p>First, let’s demonstrate the POST method. Once again, we will use curl to do the upload. In this example, the file name is <em>ajlogo.jpg</em>. The actual binary data will be truncated for readability.</p>
			<pre className="language-bash"><code className="language-bash">{`curl -v -F "file=@@ajlogo.jpg;type=image/jpeg" "http://sample.api.voicestorm.com/v1/1000/profileimage"
-H "Authorization: Bearer abcdefghijklmnopqrstuvwxyz"`}
			</code></pre>

			<h4>HTTP Request Headers and Body:</h4>
			<pre className="language-http"><code className="language-http">{`POST /v1/user/1000/profileimage HTTP/1.1
Host: sample.api.voicestorm.com
Accept: */*
Authorization: Bearer abcdefghijklmnopqrstuvwxyz
Content-Length: 3359
Content-Type: multipart/form-data; boundary=------------------------10bd448c82e655ba
--------------------------10bd448c82e655ba
Content-Disposition: form-data; name="file"; filename="ajlogo.jpg"
Content-Type: image/jpeg
<binary data truncated>
--------------------------10bd448c82e655ba`}
			</code></pre>

			<h4>HTTP Response Headers:</h4>
			<pre className="language-http"><code className=" language-http">{`HTTP/1.1 200 OK
Cache-Control: private
Content-Type: application/json; charset=utf-8
Date: Wed, 28 Aug 2013 17:28:59 GMT
Content-Length: 18`}
			</code></pre>

			<h4>Response Body:</h4>
			<pre className=" language-javascript"><code className=" language-javascript">{`{
	code:"success"
}`}
			</code></pre>

			<p>Next, we will demonstrate the PUT method. The PUT method is simpler for server-to-server uploads, but does not work from a browser context.</p>
			<h4>Request:</h4>
			<pre className="language-bash"><code className=" language-bash">{`curl -v -X PUT -T "ajlogo.jpg" "http://localhost:16071/v1/user/1000/profileimage" -H "Content-Type: image/jpeg"
-H "Authorization: Bearer abcdefghijklmnopqrstuvwxyz"`}
			</code></pre>

			<h4>HTTP Request Headers and Body:</h4>
			<pre className="language-http"><code className="language-http">{`PUT /v1/user/1000/profileimage HTTP/1.1
Host: sample.api.voicestorm.com
Accept: */*
Authorization: Bearer abcdefghijklmnopqrstuvwxyz
Content-Length: 3171
Content-Type: image/jpeg
<request body truncated>`}
			</code></pre>

			<h4>HTTP Response Headers:</h4>
			<pre className="language-http"><code className="language-http">{`HTTP/1.1 200 OK
Cache-Control: private
Content-Type: application/json; charset=utf-8
Date: Wed, 28 Aug 2013 18:18:26 GMT
Content-Length: 18`}
			</code></pre>

			<h4>Response Body:</h4>
			<pre className="language-javascript"><code className="language-javascript">{`{
	code:"success"
}`}
			</code></pre>
		</div>
	);
};

export default UploadProfileImage;


// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/UploadProfileImage.js